import { useEffect } from 'react';
import type { FeedView } from '../lib/feed';
import { price } from '../lib/format';
import { useLive } from '../store/live';

export const BASE_TITLE = 'MagicTradie! · XAUUSD Intelligence';

/** Text for the browser tab: the live bid (same as the MT5 chart) with a tick arrow, or a clear state. */
export function tabTitle(bid: number | null, tick: 'up' | 'down' | null, view: FeedView | null): string {
  if (bid === null || !view) return BASE_TITLE;
  const arrow = tick === 'up' ? '▲' : tick === 'down' ? '▼' : '•';
  if (view.tone === 'live' || view.tone === 'replay') return `${price(bid)} ${arrow} XAUUSD · MagicTradie!`;
  if (view.tone === 'delayed') return `${price(bid)} (delayed) XAUUSD · MagicTradie!`;
  // stale / disconnected / fallback: never show an old price as if it were current
  return `⚠ ${price(bid)} (${view.label}) · MagicTradie!`;
}

/** Keeps document.title in sync with the live quote so the price is visible without opening the tab. */
export function useTabTitle(view: FeedView | null, enabled: boolean): void {
  const bid = useLive((s) => s.quote?.bid ?? null);
  const tick = useLive((s) => s.tick);
  const title = enabled ? tabTitle(bid, tick, view) : BASE_TITLE;
  useEffect(() => {
    document.title = title;
  }, [title]);
  useEffect(() => () => void (document.title = BASE_TITLE), []);
}
